import React from 'react'
import {
  OnboardTitle,
  OnboardSubtitle,
  AnimatedCheck,
  CountdownTimer,
} from 'components/Antifraude'
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined'
import moment from 'moment'
import history from 'utils/history'

import { useDispatch } from 'react-redux'
import { setToken } from 'redux/reducers/token'

import styles from './styles'

const EmailSent = () => {
  const classes = styles()
  const dispatch = useDispatch()

  const handleTimeout = () => {
    dispatch(setToken(''))
    history.push('/login')
    history.go('/login')
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <LockPersonOutlinedIcon fontSize="inherit" />
          </div>
          <OnboardTitle>Nova Senha criada com sucesso</OnboardTitle>
          <OnboardSubtitle>
            Você será redirecionado em instantes para a tela de login onde
            deverá utilizar sua nova senha para acessar o sistema.
          </OnboardSubtitle>
        </div>
        <AnimatedCheck />
      </div>
      <div className={classes.hiddenCounter}>
        <CountdownTimer time={moment().add(5, 's')} callback={handleTimeout} />
      </div>
    </div>
  )
}

export default EmailSent
